export function isGoogleBusinessUrl(value) {
    if (typeof value !== 'string' || value.length > 2048) return false;
    try {
        const url = new URL(value.trim());
        if (url.protocol !== 'https:' || url.username || url.password || url.port) return false;
        if (url.hostname === 'maps.app.goo.gl' || url.hostname === 'g.page') return url.pathname.length > 1;
        if (url.hostname === 'goo.gl') return url.pathname.startsWith('/maps/');
        if (['maps.google.com', 'maps.google.it'].includes(url.hostname) && url.pathname === '/') {
            const isPlaceId = id => typeof id === 'string' && /^[A-Za-z0-9_-]{10,255}$/.test(id);
            return /^[0-9]+$/.test(url.searchParams.get('cid') || '')
                || ['place_id', 'query_place_id', 'placeid'].some(key => isPlaceId(url.searchParams.get(key)))
                || isPlaceId((url.searchParams.get('q') || '').match(/^place_id:(.+)$/)?.[1]);
        }
        return ['google.com', 'www.google.com', 'maps.google.com', 'google.it', 'www.google.it', 'maps.google.it'].includes(url.hostname)
            && (/^\/maps(?:\/|$)/.test(url.pathname) || url.pathname === '/local/writereview'
                || (url.pathname === '/search' && !!url.searchParams.get('placeid')));
    } catch {
        return false;
    }
}

export function getGoogleBusinessInputError({ googleBusinessUrl = '', googlePlaceId = '' }) {
    if (googleBusinessUrl.trim() && !isGoogleBusinessUrl(googleBusinessUrl)) {
        return 'Inserisci un link HTTPS alla tua attività su Google Maps o alle sue recensioni.';
    }
    if (googlePlaceId.trim() && !/^[A-Za-z0-9_-]{10,255}$/.test(googlePlaceId.trim())) {
        return 'Il Place ID Google non è valido. Copialo di nuovo oppure cerca la tua attività.';
    }
    return '';
}
